import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const sideOfStreetAdherenceLevelOptions = [
  'Off',
  'Minimal',
  'Moderate',
  'Average',
  'Strict',
  'Adhere',
  'StronglyAdhere',
] as const;

export const sideOfStreetAdherenceLevelSchema = createEnumSchemaPreprocessor(
  z.enum(sideOfStreetAdherenceLevelOptions),
  sideOfStreetAdherenceLevelOptions
);

export type SideOfStreetAdherenceLevel = z.infer<
  typeof sideOfStreetAdherenceLevelSchema
>;
